<div class="row mb-4">
    <div class="col-md-4 mb-4 order-md-2">
        <div class="alert alert-primary account-balance" role="alert">
            <div class="heading">
                <span>
                    <i class="icon-xl fas fa-wallet text-white mr-2"></i>
                </span>
                <h4 class="card-label text-white">Balance</h4>
            </div>
            <div class="data" (click)="getSmsAccountBalance()">
                <mat-progress-spinner mode="indeterminate" diameter="20" *ngIf="(loadingSmsAccountBalance$ | async)" color="warn" class="custom-spinner float-right"></mat-progress-spinner>
                <h4 *ngIf="!(loadingSmsAccountBalance$ | async)" class="float-right">{{(smsAccountBalance$ | async).amount}} {{(smsAccountBalance$ | async).type | titlecase}}</h4>
            </div>
        </div>
        <div class="alert alert-custom alert-white alert-shadow fade show gutter-b" role="alert">
            <div class="alert-icon">
                <span class="svg-icon svg-icon-primary svg-icon-3x">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24"/>
                            <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                            <path d="M12,16 C12.5522847,16 13,16.4477153 13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 C11,16.4477153 11.4477153,16 12,16 Z M10.591,14.868 L10.591,13.209 L11.851,13.209 C13.447,13.209 14.602,11.991 14.602,10.395 C14.602,8.799 13.447,7.581 11.851,7.581 C10.234,7.581 9.121,8.799 9.121,10.395 L7.336,10.395 C7.336,7.875 9.31,5.922 11.851,5.922 C14.392,5.922 16.387,7.875 16.387,10.395 C16.387,12.915 14.392,14.868 11.851,14.868 L10.591,14.868 Z" fill="#000000"/>
                        </g>
                    </svg>
                </span>
            </div>
            <div class="alert-text">
                <h6>Originator</h6>
                <p>Originator is the one who appears to be sending the message (e.g. STREAMUP). Only A-Z letters are supported and up to 11 characters. Some countries do not accept messages with originator.</p>
                <h6>Recipients</h6>
                <p>Phone numbers separated by comma, e.g. 446521545881,306947154253 (no spaces)</p>
                <h6>Flash</h6>
                <p>Also know as class 0 message, this message will appear instantly on the receiver' s phone.</p>
            </div>
        </div>
    </div>
    <div class="col-md-8 mb-4">
        <div class="card card-custom">
            <form [formGroup]="smsForm">
                <div class="card-body">
                    <div class="my-card-title">
                        <span class="svg-icon svg-icon-primary svg-icon-2x mr-5">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M16,15.6315789 L16,12 C16,10.3431458 14.6568542,9 13,9 L6.16183229,9 L6.16183229,5.52631579 C6.16183229,4.13107011 7.29290239,3 8.68814808,3 L20.4776218,3 C21.8728674,3 23.0039375,4.13107011 23.0039375,5.52631579 L23.0039375,13.1052632 L23.0206157,17.786793 C23.0215995,18.0629336 22.7985408,18.2875874 22.5224001,18.2885711 C22.3891754,18.2890457 22.2612702,18.2363324 22.1670655,18.1421277 L19.6565168,15.6315789 L16,15.6315789 Z" fill="#000000"/>
                                    <path d="M1.98505595,18 L1.98505595,13 C1.98505595,11.8954305 2.88048645,11 3.98505595,11 L11.9850559,11 C13.0896254,11 13.9850559,11.8954305 13.9850559,13 L13.9850559,18 C13.9850559,19.1045695 13.0896254,20 11.9850559,20 L4.10078614,20 L2.85693427,21.1905292 C2.65744295,21.3814685 2.34093638,21.3745358 2.14999706,21.1750444 C2.06092565,21.0819836 2.01120804,20.958136 2.01120804,20.8293182 L2.01120804,18.32426 C1.99400175,18.2187196 1.98505595,18.1104045 1.98505595,18 Z M6.5,14 C6.22385763,14 6,14.2238576 6,14.5 C6,14.7761424 6.22385763,15 6.5,15 L11.5,15 C11.7761424,15 12,14.7761424 12,14.5 C12,14.2238576 11.7761424,14 11.5,14 L6.5,14 Z M9.5,16 C9.22385763,16 9,16.2238576 9,16.5 C9,16.7761424 9.22385763,17 9.5,17 L11.5,17 C11.7761424,17 12,16.7761424 12,16.5 C12,16.2238576 11.7761424,16 11.5,16 L9.5,16 Z" fill="#000000" opacity="0.3"/>
                                </g>
                            </svg>
                        </span>
                        <h5>Sms Center</h5>
                    </div>
                    <div class="row">
                        <div class="col-10 col-lg-11">
                            <div class="form-group">
                                <label >Sender <span class="text-danger">*</span></label>
                                <input type="text" class="form-control"  placeholder="Enter sender" formControlName="originator"/>
                                <span *ngIf="f.originator.invalid && (f.originator.dirty || f.originator.touched)" class="form-text text-danger">Max length is 11 characters!</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-10 col-lg-11">
                            <div class="form-group">
                                <label>Recipients <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" placeholder="44..." formControlName="recipients"/>
                                <span *ngIf="f.recipients.invalid && (f.recipients.dirty || f.recipients.touched)" class="form-text text-danger">Only digits and comma allowed!</span>
                            </div>
                        </div>
                        <div class="col-2 col-lg-1 predefined">
<!--                            <button mat-icon-button>-->
<!--                                <mat-icon aria-label="Contacts">contacts</mat-icon>-->
<!--                            </button>-->
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-10 col-lg-11">
                            <div class="form-group mb-3">
                                <label>Message<span class="text-danger">*</span></label>
                                <textarea class="form-control" rows="5" formControlName="message"></textarea>
                            </div>
                        </div>
                        <div class="col-2 col-lg-1 predefined">
                            <button mat-icon-button>
                                <mat-icon aria-label="Predefined sms" (click)="showPredefinedSms()">list</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="form-group mb-4">
                        <label class="checkbox checkbox-outline checkbox-primary">
                            <input type="checkbox" name="check_flash" formControlName="flash"/>
                            <span class="mr-2"></span>
                            Flash (SMS is shown directly on screen)
                        </label>
                    </div>
                    <div class="compose-sms-action-panel mt-2">
                        <button type="reset" class="btn btn-secondary">Clear</button>
                        <button type="button" [disabled]="smsForm.invalid" (click)="sendSMS()" class="btn btn-primary">Send</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="row mb-4">
    <div class="col-12 mb-4">
        <div class="card card-custom">
            <div class="card-header border-0 bg-primary">
                <div class="card-title">
				    <span class="card-icon">
					    <i class="flaticon2-chat-1 text-white"></i>
                    </span>
                    <h3 class="card-label text-white">Recent Activity</h3>
                </div>
                <div class="card-toolbar text-white">
                    <button mat-icon-button (click)="getRecentActivity()">
                        <mat-icon aria-label="Refresh">autorenew</mat-icon>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <mat-progress-bar mode="indeterminate" *ngIf="(loadingSmsAccountHistory$ | async)"></mat-progress-bar>
                <div *ngIf="!(loadingSmsAccountHistory$ | async) &&!(hasSMSes$ | async)">No recent activity!</div>
                <div *ngIf="!(loadingSmsAccountHistory$ | async) && (hasSMSes$ | async)" class="table-responsive">
                    <table class="table text-center">
                        <thead>
                        <tr>
                            <th scope="col" class="d-none d-sm-table-cell">Sender</th>
                            <th scope="col">Recipient</th>
                            <th scope="col">Message</th>
                            <th scope="col">Date</th>
                            <th scope="col">Delivered</th>
                        </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let sms of SMSes$ | async">
                            <ng-container [ngTemplateOutlet]="RecentActivityItemTemplate" [ngTemplateOutletContext]="{item: sms}"></ng-container>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #RecentActivityItemTemplate let-item="item">
    <tr>
        <td nowrap class="d-none d-sm-table-cell">{{item.originator}}</td>
        <td nowrap>{{item.firstRecipientPhoneNumber}}
            <span *ngIf="(item.totalRecipients > 1)" class="label label-success mr-2">+{{item.totalRecipients - 1}}</span>
        </td>
        <td class="text-left">{{item.body | maxCharacters: 100}}</td>
        <td nowrap class="text-right">{{item.created}}</td>
        <td nowrap>
            <span *ngIf="(item.totalRecipients === 1)" class="label label-xl label-dot label-success"></span>
            <span *ngIf="(item.totalRecipients > 1)" class="label label-inline label-light-{{item.totalRecipients === item.totalRecipientsDelivered ? 'success' : 'warning'}} font-weight-bold">({{item.totalRecipientsDelivered}} / {{item.totalRecipients}})</span>
        </td>
    </tr>
</ng-template>